<div class="page-content">
    <p-panel header="Projects" class="no-x-padding">
        <app-project-crud></app-project-crud>
    </p-panel>
</div>
